import React from 'react';
import { Container } from 'react-bootstrap';

const FormContainer = ({ children, title }) => (
    <Container className="my-4">
        <h2 className="mb-4">{title}</h2>
        <div className="bg-light p-4 rounded shadow-sm">{children}</div>
    </Container>
);

export default FormContainer;
